import React from 'react';
import { Box, CircularProgress } from '@material-ui/core/';
import styled from 'styled-components';
// import { useSelector } from 'react-redux';

const ContainedDiv = styled.div`
position:relative;
  width: 100%;
  margin:0;
  height: 100%;
  text-align: center;
  p{
    font-size: small;
    font-weight: bold;
  }
`;

export default function DownloadLoading({
  action,
  color = 'primary',
  thickness = 4,
  size = 25,
  message,
  ...props
}) {
  return (
    <ContainedDiv>
      <Box p={1}>
        {message && <p>{message}</p>}
        <CircularProgress color={color} size={size} thickness={thickness} />
      </Box>
    </ContainedDiv>
  );
}
